import script from "./BackdropModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackdropModal.vue?vue&type=script&setup=true&lang=ts"

import "./BackdropModal.vue?vue&type=style&index=0&id=d0cc487a&lang=scss"

const __exports__ = script;

export default __exports__